import React from 'react';

export interface NumberTagProps {
    value: number | string;
    emphasis?: boolean;
    /**
     * Names the bare number for assistive tech — "3 schemas" rather than "3". Rendered as
     * visually-hidden text, because `aria-label` on a plain span is not honoured.
     */
    'aria-label'?: string;
    className?: string;
}

// Compact monospace count pill for numeric counts in tables and lists.
export const NumberTag: React.FC<NumberTagProps> = ({
    value,
    emphasis = false,
    'aria-label': ariaLabel,
    className = '',
}) => {
    const classes = [
        'malachite-number-tag',
        emphasis ? 'malachite-number-tag-emphasis' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    if (ariaLabel) {
        return (
            <span className={classes}>
                <span aria-hidden="true">{value}</span>
                <span className="sr-only">{ariaLabel}</span>
            </span>
        );
    }
    return <span className={classes}>{value}</span>;
};

export default NumberTag;
